
import axios from 'axios'
import React from 'react';

// old path = /provinces
// ดึง ข้อมูล จังหวัด
export const getProvince = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/address/provioce`,
     {
      headers: {
        "ngrok-skip-browser-warning": "true"
      }
     }
      
    )
    let data = response.data;
    let tempdata = [];

    for (let i = 0; i < data.length; i++) {
      tempdata.push({
        value: data[i].id,
        label: data[i].name_th,
      });
    }
    // console.log(tempdata);
    return tempdata;
  } catch (error) {
    console.error('Error fetching data:', error)
    return [];
  }
}


// old path = /districts
// ดึง ข้อมูล จังหวัด
export const getDistricts = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/address/districts`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true"
        }
      }
    )
    let data = response.data;
    let tempdata = [];
    // console.log("response", data)
    for (let i = 0; i < data.length; i++) {
      tempdata.push({
        value: data[i].id,
        label: data[i].name_th,
        province_id: data[i].province_id
      });
    }
    return tempdata;
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}


// old path = /subdistricts
// ดึง ข้อมูล ตำบล
export const getSubDistrict = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/address/subdistricts`,
      {
        headers: {
          "ngrok-skip-browser-warning": "true"
        }
      }
    )
    let data = response.data;
    let tempdata = [];

    for (let i = 0; i < data.length; i++) {
      tempdata.push({
        value: data[i].id,
        label: data[i].name_th,
        district_id: data[i].amphure_id,
        zip_code: data[i].zip_code
      });
    }
    // console.log("ตำบล",tempdata)
    return tempdata;
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}

export const getTimeSlotsActive = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/all/active`,{
      headers: {
          "ngrok-skip-browser-warning": "true"
      }
    })
    // console.log(response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}

export const getTimeSlotSpecialDay = async(date)=>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/timespecial/date/${date}`,{
      headers: {
          
          "ngrok-skip-browser-warning": "true"
      }
    })
    // console.log(response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}

export const getTimeSlots = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/all`,{
      headers: {
          'Authorization': `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true"
      }
  })
    // console.log(response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}

export const UpdateTimeSlotsAll = async (data,token) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/all/update`,data,{
      headers: {
          'Authorization': `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true"
      }
  })
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    return []
  }
}

export const UpdateTimeSlots = async (data,token) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/update`,{updates : data},{
      headers: {
          'Authorization': `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true"
      }
  })
    return response.data
  } catch (error) {
    console.log('Error fetching data:', error)
    return []
  }
}

export const GetDownloadExcelBookingByDate = async (date,token) => {
  try {
    // ส่ง request เพื่อดาวน์โหลดไฟล์ Excel
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/getTicketboatExcel/${date}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true" // ส่ง Authorization header ถ้าจำเป็น
      },
      responseType: 'blob', // สำคัญ: ใช้ 'blob' เพื่อจัดการกับ binary data
    });

    // สร้าง URL object สำหรับไฟล์ Excel
    const url = window.URL.createObjectURL(new Blob([response.data]));
    
    // สร้างลิงก์สำหรับดาวน์โหลด
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ticketboat_data.xlsx'); // กำหนดชื่อไฟล์ที่จะดาวน์โหลด
    document.body.appendChild(link);
    link.click();
    link.remove(); // ลบลิงก์ออกหลังจากใช้งานเสร็จ

  } catch (error) {
    console.error('Error downloading the file', error);
    throw error;
  }
};

export const GenerateInvoice = async () => {
  try {
    // ทำการเรียก API ไปยัง backend ของคุณ
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/generate-invoice`, {
      responseType: 'blob', // กำหนด response type เป็น blob สำหรับไฟล์ PDF
    });

    // สร้าง URL สำหรับดาวน์โหลด PDF
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'invoice.pdf'); // กำหนดชื่อไฟล์ที่ต้องการดาวน์โหลด
    document.body.appendChild(link);
    link.click();
    link.remove();
    
  } catch (error) {
    console.error('เกิดข้อผิดพลาดในการดาวน์โหลดไฟล์', error);
  }
}


export const getTimeSpecialdaysTime = async (date,time) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/specialdayTime/${date}/${time}`,{
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data[0] // Save the response data
  } catch (err) {
    throw err // Log the error
  }
};

export const createSpecialDate = async (token,date,data)=>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/timespecial/create`,{date:date, data:data},{

      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const getSpecialDate = async ()=>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/timespecial/date`,{
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const getBookingByDateTime = async (date,time,token) =>{
  try {
    // console.log('Getting :',`/api/booking/ticket/datetime/${date}/${time}`)
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/datetime/${date}/${time}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true"
        }
      }
    );
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const GetTimeSlotsByTime = async (time,token) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/all/active/time/${time}`,{
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const Getcountry = async () =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/address/country`,{
      headers: {
        "ngrok-skip-browser-warning": "true"
      }
    });
    let data = response.data
    let tempdata = [];

    for (let i = 0; i < data.length; i++) {
      tempdata.push({
        value: data[i].num_code,
        label: data[i].en_short_name,
      });
    }
    // console.log(tempdata);
    return tempdata;
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const DeleteTimeSpecial = async (date,token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/timespecial/delete/date/${date}`,{
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const GetSpecialDateTime = async (date,time) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/timespecial/datetime/${date}/${time}`,{
      headers: {
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}

export const getTimebyTime = async (time) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/timeslot/time/${time}`,{
      headers: {
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error;
  }
}